import { api, download } from "../helpers";

const prefix = "/judge";

export const getSettings = (param, token) => {
	return api(`${prefix}/settings`, "GET", undefined, param, token);
};

export const getJudgeProfileList = (param, token) => {
	return api(`${prefix}/profile-list`, "GET", undefined, param, token);
};

export const postSettings = (payload, token) => {
	return api(`${prefix}/settings`, "POST", payload, undefined, token);
};

export const getQuestionsList = (param, token) => {
	return api(`${prefix}/exam/questions`, "GET", undefined, param, token);
};

export const getQuestion = (payload, token) => {
	const { id } = payload;

	return api(
		`${prefix}/exam/questions/${id}`,
		"get",
		undefined,
		undefined,
		token
	);
};

export const updateQuestion = (payload, token) => {
	return api(`${prefix}/exam/questions`, "PUT", payload, undefined, token);
};

export const postQuestion = (payload, token) => {
	return api(`${prefix}/exam/questions`, "POST", payload, undefined, token);
};

export const deleteQuestionsById = (payload, token) => {
	const { id } = payload;

	return api(
		`${prefix}/exam/questions/${id}`,
		"DELETE",
		undefined,
		undefined,
		token
	);
};

export const getJudgeProfile = (payload, token) => {
	const { id } = payload;

	return api(`${prefix}/profile/${id}`, "get", undefined, undefined, token);
};

export const updateJudgeProfile = (payload, token) => {
	return api(`${prefix}/profile/update`, "PUT", payload, undefined, token);
};

export const exportJudgeProfiles = (params, token) =>
	download(`${prefix}/profile-list/export`, params, token);
